import React, { ReactElement } from 'react';
import { QButton, QHeading, QIconButton, QSelect, QSelectItem } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { BulkQSelect, BulkSelectCloseButton, BulkSelectContainer } from '../../../../styles/BulkSelect.styles';
import { CommonProps } from '../../types';

type BulkSelectProps = Pick<CommonProps, 'incrementStep' | 'users'> & {
  allItemsAssigned: boolean;
  clearSelected: () => void;
  selected: Set<number>;
  updateOwnerOfSelectedItems: (newOwner: QSelectItem) => void;
};

// BulkSelect component is used to reassign multiple entities at once
const BulkSelect = ({
  allItemsAssigned,
  clearSelected,
  incrementStep,
  selected: items,
  users,
  updateOwnerOfSelectedItems,
}: BulkSelectProps): ReactElement => {
  const { t } = useTranslation();
  return (
    <BulkSelectContainer>
      <QHeading size="xs">{t('reassignEntities.allSelected', { count: items.size })}</QHeading>
      <BulkQSelect>
        <QSelect
          data-cy="bulk-select"
          aria-label="bulk_select"
          options={users}
          onChange={(item) => item && updateOwnerOfSelectedItems(item)}
        />
      </BulkQSelect>
      <QButton
        data-cy="save-button"
        isDisabled={!allItemsAssigned}
        type="submit"
        variant="outline"
        onClick={incrementStep}
      >
        {t('reassignEntities.save')}
      </QButton>
      <BulkSelectCloseButton>
        <QIconButton aria-label="close_bulk_select" iconName="X" size="lg" onClick={clearSelected} />
      </BulkSelectCloseButton>
    </BulkSelectContainer>
  );
};

export default BulkSelect;
